import React from 'react';
import './CommonLoader.scss';

const CommonLoader: React.FC = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default CommonLoader;